import React from 'react';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { AI_COLORS, AI_FONTS, AudioPlayer, GlowCard } from '../shared';
import './styles.css';

function AdultoIdososHome() {
  const isMobile = useIsMobile();

  return (
    <div style={{ fontFamily: AI_FONTS.body }}>
      {/* Hero */}
      <div className="adulto-hero">
        <video
          className="adulto-hero-video"
          autoPlay
          loop
          muted
          playsInline
          src={`${process.env.PUBLIC_URL || ''}/videos/hero.mp4`}
        />
        <div className="adulto-hero-overlay" />
        <div className="adulto-hero-content">
          <h2 className="" style={{ paddingTop: 40 }}>
              Seja bem-vindo(a) ao @ViverSorrindo

              <p className='outfit' style={{ textAlign: 'center', marginTop: 0, fontSize: 24, fontWeight: 'bold' }}>Cuidar todos os dias para sorrir a vida toda!</p>
          </h2>
          <p className="adulto-description">
            Desenvolvido pelo <b>PPGO-UFU</b> em parceria com o <b>HOUFU</b>, <b>FOUFU</b> e o{' '}
            <b>INCT-Odonto</b>.
          </p>
          <div style={{ marginTop: 22, display: 'flex', justifyContent: 'center' }}>
            <AudioPlayer src="boas-vindas.m4a" label="Ouça as boas-vindas" />
          </div>
        </div>
      </div>

      {/* Aprenda sobre */}
      <div
        style={{
          background: AI_COLORS.bgBlue50,
          padding: '48px 24px',
          textAlign: 'center',
          borderBottom: `2px solid ${AI_COLORS.bgBlue100}`,
        }}
      >
        <h2
          style={{
            fontFamily: AI_FONTS.title,
            color: AI_COLORS.blue900,
            fontSize: '1.5rem',
            marginBottom: 20,
          }}
        >
          Neste website você poderá aprender sobre:
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
            gap: 14,
            maxWidth: 860,
            margin: '0 auto',
          }}
        >
          {[
            { icon: '🦷', texto: 'Como manter a boca limpa e saudável' },
            { icon: '🔧', texto: 'Como cuidar de próteses e implantes' },
            { icon: '🔍', texto: 'Problemas que podem aparecer na sua boca' },
            { icon: '🥗', texto: 'Alimentação e hábitos saudáveis' },
            { icon: '💙', texto: 'Saúde física e emocional' },
            { icon: '🔗', texto: 'A relação entre saúde bucal e saúde geral' },
          ].map((item, i) => (
            <GlowCard
              key={i}
              style={{
                background: AI_COLORS.white,
                borderRadius: 12,
                padding: '14px 18px',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                boxShadow: '0 2px 8px rgba(1,87,155,0.07)',
                textAlign: 'left',
              }}
            >
              <span style={{ fontSize: '1.4rem', flexShrink: 0 }}>{item.icon}</span>
              <span style={{ fontSize: '0.93rem', color: AI_COLORS.textDark }}>{item.texto}</span>
            </GlowCard>
          ))}
        </div>
      </div>

      <div className="adulto-sections-container">
        
      </div>
    </div>
  );
}

export default AdultoIdososHome;
